// extracted by mini-css-extract-plugin
export default {"special-div":"SpecialSection_special-div__PAYNo","special-title":"SpecialSection_special-title__ghuWm"};